import type {ReactNode} from 'react';

export const MAX_OPACITY_REDUCTION = 0.4;
export const OPACITY_DIVISOR = 150;
export const TRANSITION_DURATION_MS = 250;

export interface SwipeableReattachWrapperProps {
  children: ReactNode;
  onReattach: VoidFunction | undefined;
  enabled: boolean;
  className?: string;
}
